export enum AgentTypeEnum {
  OPENAI = 'OPENAI',
  YANDEX = 'YANDEX',
  DEEPSEEK = 'DEEPSEEK',
  MISTRAL = 'MISTRAL',
}